module.exports = __webpack_public_path__ + "e744eb75af7c7ec6832579bc19b0f00c.woff2";